import type { EntityConfig } from "@/v2/framework/registry/types";
import { createCategoriesView } from "./grid/view";

export default {
  id: "categories",
  name: "categories",
  title: "metadata.categories",
  position: 2,
  create: (ctx) => createCategoriesView(ctx),
} satisfies EntityConfig;
